// removed by extract-text-webpack-plugin
module.exports = {"container":"src-modules-orders-NewOrderModal-NewOrderPaymentsForm-__NewOrderPaymentsForm__container--3AUS_","others-container":"src-modules-orders-NewOrderModal-NewOrderPaymentsForm-__NewOrderPaymentsForm__others-container--3ifjH","pp-tile":"src-modules-orders-NewOrderModal-NewOrderPaymentsForm-__NewOrderPaymentsForm__pp-tile--16xUb","pp-tiles-container":"src-modules-orders-NewOrderModal-NewOrderPaymentsForm-__NewOrderPaymentsForm__pp-tiles-container--zAFF3"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/orders/NewOrderModal/NewOrderPaymentsForm/NewOrderPaymentsForm.less
// module id = 1887
// module chunks = 0